import { useState, useEffect } from "react";
import { useAppContext } from "../../context";
import { fetchProvince } from "./api";

// Carica una volta la lista delle province italiane dal servizio select2.
// In caso di errore (es. endpoint non ancora deployato) ritorna lista vuota: i
// consumatori applicano un fallback ai valori presenti nei documenti.
export const useProvince = () => {
  const { isProd } = useAppContext();
  const env = isProd ? "prod" : "dev";
  const [province, setProvince] = useState([]);

  useEffect(() => {
    let active = true;
    fetchProvince(env)
      .then((list) => {
        if (active) setProvince(list);
      })
      .catch((e) => {
        console.error("Errore caricamento province:", e);
      });
    return () => {
      active = false;
    };
  }, [env]);

  return province; // [{ id, sigla, nome, codice, regione, text }]
};
